import React, { FC, MouseEvent } from "react";
import { useNotificationBannersContext } from "Contexts/notification-banners-context";
import { NotificationBanner } from "./notification-banner";
import styles from "./notification-banners.css";
import {
    useGlobalAlertFraudBanner,
    useGlobalAnnualKycFollowUpBanners,
    useGlobalCompanyStatusNotificationBanners,
    useGlobalErpIntegrationOAuthReactivationBanner,
    useGlobalPayoutInformationBanners,
} from "./global";

export const NotificationBanners: FC = () => {
    const { notifications, handleRemoveNotification } =
        useNotificationBannersContext();

    useGlobalAnnualKycFollowUpBanners();
    useGlobalCompanyStatusNotificationBanners();
    useGlobalErpIntegrationOAuthReactivationBanner();
    useGlobalPayoutInformationBanners();

    // SOLUTION for notfy users about fraud, shall be removed when not necessary anymore
    useGlobalAlertFraudBanner();

    if (!notifications || notifications.length < 1) return null;

    const handleNotificationClosed = (event?: MouseEvent<HTMLElement>) => {
        const { notificationid } = event?.currentTarget.dataset || {};
        if (notificationid) {
            handleRemoveNotification(notificationid);
        }
    };

    const globalNotifications = notifications.filter((m) => m.isGlobal);
    const localNotifications = notifications.filter((m) => !m.isGlobal);
    const showLocalNotifications = localNotifications.length > 0;
    const showGlobalNotifications = globalNotifications.length > 0;

    return (
        <>
            {showLocalNotifications && (
                <div className={styles.outerLocalContainer}>
                    <div className={styles.innerLocalContainer}>
                        {localNotifications.map((notification) => (
                            <NotificationBanner
                                key={notification.id}
                                notification={notification}
                                onNotificationClose={handleNotificationClosed}
                            />
                        ))}
                    </div>
                </div>
            )}
            {showGlobalNotifications && (
                <div className={showLocalNotifications ? styles.faded : ""}>
                    {globalNotifications.map((notification) => (
                        <NotificationBanner
                            key={notification.id}
                            notification={notification}
                            onNotificationClose={handleNotificationClosed}
                        />
                    ))}
                </div>
            )}
        </>
    );
};
